import styled from 'styled-components'
import colors from '../../../configuration/colors'

const InputLabel = styled.div`
  color: ${colors.dove}
  font-size: 11px;
  line-height: 16px;
  margin-top: 20px;
  font-weight: 500;
`

export default InputLabel



// WEBPACK FOOTER //
// ./src/components/typography/Input/InputLabel.js